"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineEmitter = void 0;
const async_1 = require("../async");
const get_iterable_from_emitter_1 = require("./get-iterable-from-emitter");
function combineEmitter(eventEmitter, optionsOrKeyA, keyB, options) {
    if (!keyB && typeof optionsOrKeyA !== 'function') {
        options = optionsOrKeyA;
        optionsOrKeyA = undefined;
    }
    return async_1.combineAsync.call(this, (0, get_iterable_from_emitter_1.getIterableFromEmitter)(eventEmitter, options), optionsOrKeyA, keyB);
}
exports.combineEmitter = combineEmitter;
